export const formatCareStageLabel = (careStage?: string | null): string => {
  if (!careStage) return '';
  return careStage
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};
